import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  custom: {
    families: ['Mont, Mont Book'],
    urls: ['/fonts/Mont/stylesheet.css']
  },
})
